import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {ApRequestConfig, AprimaHttpClientService} from 'webcommon/legacy-common';

const endpointBase = 'patient';

@Injectable({
  providedIn: 'root',
})
export class PatientPortalHttpClientService {
  constructor(
    private aprimaHttpClientService: AprimaHttpClientService,
  ) { }

  getFullUrl(endpointUrl?: string): string {
    const baseUrl = this.aprimaHttpClientService.getFullUrl(endpointBase, endpointUrl);
    return baseUrl;
  }

  sendGetRequest<T>(endpointUrl: string, params?: HttpParams, config?: ApRequestConfig): Observable<T> {
    return this.aprimaHttpClientService.sendGetRequest<T>(endpointBase, endpointUrl, params, config);
  }

  sendPostRequest<T>(endpointUrl: string, body: any, params?: HttpParams): Observable<T> {
    return this.aprimaHttpClientService.sendPostRequest<T>(endpointBase, endpointUrl, body, params);
  }
}
